import React from 'react';
import { motion } from 'framer-motion';
export function PartnerSection() {
  const imgPartners = [{
    name: 'AWS',
    src: 'https://upload.wikimedia.org/wikipedia/commons/9/93/Amazon_Web_Services_Logo.svg',
    w: 80
  }, {
    name: 'Microsoft Azure',
    src: 'https://upload.wikimedia.org/wikipedia/commons/f/fa/Microsoft_Azure.svg',
    w: 90
  }, {
    name: 'Google Cloud',
    src: 'https://cdn.simpleicons.org/googlecloud/4285F4',
    w: 90
  }, {
    name: 'SAP',
    src: 'https://cdn.simpleicons.org/sap/0FAAFF',
    w: 80
  }, {
    name: 'T-Systems',
    src: 'https://cdn.simpleicons.org/deutschetelekom/E20074',
    w: 70
  }, {
    name: 'NVIDIA',
    src: 'https://cdn.simpleicons.org/nvidia/76B900',
    w: 90
  }];
  return <section id="partner" className="py-24 bg-[#020611]" data-id="element-264">
      <div className="container mx-auto px-6" data-id="element-265">
        <div className="text-center max-w-3xl mx-auto mb-16" data-id="element-266">
          <motion.h2 initial={{
          opacity: 0,
          y: 20
        }} whileInView={{
          opacity: 1,
          y: 0
        }} viewport={{
          once: true
        }} className="text-3xl md:text-4xl font-heading mb-4" data-id="element-267">
            Unterstützt von den Besten
          </motion.h2>
          <motion.p initial={{
          opacity: 0,
          y: 20
        }} whileInView={{
          opacity: 1,
          y: 0
        }} viewport={{
          once: true
        }} transition={{
          delay: 0.1
        }} className="text-muted" data-id="element-268">
            Wir arbeiten mit führenden Technologieanbietern zusammen, damit Ihre
            Sprints auf Enterprise-Grade-Infrastruktur laufen.
          </motion.p>
        </div>

        <motion.div initial={{
        opacity: 0
      }} whileInView={{
        opacity: 1
      }} viewport={{
        once: true
      }} transition={{
        delay: 0.2,
        duration: 0.8
      }} className="grid grid-cols-2 md:grid-cols-3 lg:grid-cols-6 gap-10 md:gap-12 items-center justify-items-center" data-id="element-269">
          {imgPartners.map((p, i) => <motion.div key={p.name} initial={{
          opacity: 0,
          y: 15
        }} whileInView={{
          opacity: 1,
          y: 0
        }} viewport={{
          once: true
        }} transition={{
          delay: 0.1 + i * 0.08
        }} className="flex flex-col items-center gap-3 group cursor-default" data-id="element-270">
              <div className="h-16 flex items-center justify-center" data-id="element-271">
                <img src={p.src} alt={p.name} style={{
              width: p.w,
              height: 'auto',
              maxHeight: 48
            }} className="opacity-50 brightness-200 group-hover:opacity-100 group-hover:brightness-100 transition-all duration-500" data-id="element-272" />
              </div>
              <span className="text-xs font-mono text-muted-dark group-hover:text-muted transition-colors duration-500" data-id="element-273">
                {p.name}
              </span>
            </motion.div>)}
        </motion.div>

        <motion.div initial={{
        opacity: 0
      }} whileInView={{
        opacity: 1
      }} viewport={{
        once: true
      }} transition={{
        delay: 0.4
      }} className="text-center mt-16" data-id="element-274">
          <p className="text-sm text-muted-dark border border-border inline-block px-6 py-2 rounded-full" data-id="element-275">
            Partnerschaftsanfragen willkommen — wir suchen aktiv nach
            Technologie- und Industriepartnern.
          </p>
        </motion.div>
      </div>
    </section>;
}